import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=55d38e58&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d38e58",
  null
  
)

export default component.exports